import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { MONTH_BUTTON } from './constants'
import { getAcceptMonthButton } from './get-accept-month-button'
import type { GetAcceptManagerButtonProps } from './types'

const getAcceptManagerButton = ({
  t,
  sendEvent,
  refetch,
  setMessageDrawerProps,
  openToast,
}: GetAcceptManagerButtonProps) =>
  ({
    label: t('workTimeControl.buttons.accept'),
    testId: 'monthly-sheet-detail_accept-manager',
    hiddenActions: [
      ...[
        getAcceptMonthButton({
          sendEvent,
          refetch,
          setMessageDrawerProps,
          t,
          month: MONTH_BUTTON.this,
          openToast,
        }),
      ],
      ...[
        getAcceptMonthButton({
          sendEvent,
          refetch,
          setMessageDrawerProps,
          t,
          month: MONTH_BUTTON.next,
          openToast,
        }),
      ],
    ],
    variant: 'text',
    color: 'error',
  } as Action)

export default getAcceptManagerButton
